import client from './client';
import { compactParams } from '../utils/pick';

export const listAdminNotifications = (params) =>
  client.get('/admin/notifications', { params: compactParams(params) });

export const getAdminNotificationSummary = () => client.get('/admin/notifications/summary');

export const markAdminNotificationRead = (id) => client.post(`/admin/notifications/${id}/read`);

export const markAllAdminNotificationsRead = () => client.post('/admin/notifications/read-all');
